import { useState, useEffect, useCallback }     from 'react'
import { UseInputFile }                         from "../../contexts/InputFilePageContext"
import DatepickerContainer                      from '../Datepicker/DatepickerContainer'
import api                                      from '../../services/api'
import '../../styles/TableFilter.css'

function InputFileDateFilter() {

    const { 
        
        selectedHorizonTypeId, 
        setSelectedDate, 
        selectedDate,
        updateDatepicker
    
    } = UseInputFile()
    
    const [ _datepickerView,           _setDatepickerView        ] = useState('year')
    const [ _datepickerFormat,         _setDatepickerFormat      ] = useState('YYYY')
    const [ _availAbleDates,           _setAvailAbleDates        ] = useState([])

    const _fetchDemandTypeData = useCallback(async () => {
        
        try {

            const response = await api.get(
                `/getDemandPostDateListByDemandHorizonId/${selectedHorizonTypeId}`
            )

            const { demandHorizon, demandDateList, demandDateList_v2 } = response.data

            if (response.status !== 200) return

            const { dateInputFilterFormat, horizonPlanFormat } = demandHorizon.ownerHorizonOfPlan

            _setDatepickerView(dateInputFilterFormat)
            _setDatepickerFormat(horizonPlanFormat)
            _setAvailAbleDates(demandDateList_v2)
            
            setSelectedDate(demandDateList_v2[0])
            
        } catch (error) {
            console.log(error)
        }

    }, [ selectedHorizonTypeId, setSelectedDate ])

    useEffect(() => {


        setSelectedDate(null)
        if( selectedHorizonTypeId ) _fetchDemandTypeData()
 
    }, [ selectedHorizonTypeId, updateDatepicker, _fetchDemandTypeData ])

    const _handleDateChange = (newValue) => {
        setSelectedDate(newValue)
    }
    return (
        
        <div className="quebra_linha flex gap-[10px] flex-row z-10 text-[0.8rem] text-nowrap"> 
 

            <DatepickerContainer
                
                datesList={_availAbleDates}
                format={_datepickerFormat}
                selectedValue={selectedDate}
                onChange={(newValue) => _handleDateChange(newValue)}
            
            />

       </div>
    )
}

export default InputFileDateFilter

